import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { getInstantWebsiteSettings } from './instant-website-data.reducer';
import { filter, shareReplay } from 'rxjs/operators';
import { IInstantWebsiteSettings } from './instant-website-data.data';

@Injectable()
export class InstantWebsiteDataStore {
  instantWebsiteSettings$: Observable<IInstantWebsiteSettings> = this._store.select(
    getInstantWebsiteSettings
  );

  constructor(private _store: Store<any>) {}

  getInstantWebsiteSettings(): Observable<IInstantWebsiteSettings> {
    return this.instantWebsiteSettings$.pipe(
      filter((x) => !!x),
      shareReplay(1)
    );
  }
}
